import { Component, inject, ChangeDetectionStrategy, signal, computed } from '@angular/core';
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';

import { HeaderComponent } from './core/components/header/header.component';
import { SideBarComponent } from './core/components/side-bar/side-bar.component';
import { LoadingComponent } from './shared/components/loading/loading.component';
import { FooterComponent } from './core/components/footer/footer.component';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { SidebarService } from './core/services/sidebar/sidebar.service';
import { filter } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { HelpChatWidgetComponent } from './shared/components/help-chat-widget/help-chat-widget.component';
import { NavigationContextService } from './core/services/navigation-context/navigation-context.service';
import { MobileBottomNavComponent } from './core/components/mobile-bottom-nav/mobile-bottom-nav.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
    RouterOutlet,
    HeaderComponent,
    FooterComponent,
    SideBarComponent,
    LoadingComponent,
    ConfirmPopupModule,
    DynamicDialogModule,
    HelpChatWidgetComponent,
    MobileBottomNavComponent
],

})
export class AppComponent {
  private readonly router = inject(Router);
  private readonly sidebarService = inject(SidebarService);
  // Sem uso direto aqui, mas NÃO remover: o serviço assina os eventos do
  // router no construtor e precisa ser instanciado no boot — na landing
  // /oferta o header (outro injetor dele) não é renderizado.
  private readonly navigationContext = inject(NavigationContextService);

  /**
   * Marketing landing at `/oferta` renders without global chrome (header, sidebar, footer).
   */
  protected readonly isOfertaStandaloneLanding = signal(false);

  // Layout State from Service
  readonly isSidebarOpen = this.sidebarService.isOpen;
  readonly isMobile = this.sidebarService.isMobile;
  
  // Use service logic for push content
  readonly shouldPushContent = computed(() => {
    return this.isSidebarOpen() && this.sidebarService.isPushMode();
  });

  constructor() {
    const syncOfertaLayout = (): void => {
      const path = this.router.url.split(/[?#]/)[0];
      this.isOfertaStandaloneLanding.set(path === '/oferta');
    };
    syncOfertaLayout();
    this.router.events
      .pipe(
        filter((e): e is NavigationEnd => e instanceof NavigationEnd),
        takeUntilDestroyed()
      )
      .subscribe(syncOfertaLayout);
  }
}
